export default function(dsf,options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    defaultValue: null,
    valueAttributes: [
      {
        name: "开始时间",
        code: "stime",
        type: dsf.metadata.getDataType("time"),
        length: null,
        defaultValue: null,
        unit: null,
        textType:"normal"
      }, {
        name: "结束时间",
        code: "etime",
        type: dsf.metadata.getDataType("time"),
        length: null,
        defaultValue: null,
        unit: null,
        encrypt:false,
        textType:"normal"
      }
    ]
  };
}